import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getDate } from 'utils/DateUtil'
import { DATE } from './KeyFigureConstants'
import { getLongNumber, getNumberFormat } from '../../utils/NumberUtil'
import { filter, isUndefined } from 'lodash'
import { Card, CardContent, Grid, Tooltip } from '@mui/material'
import { formatMilliers, getI18nOrLabel } from 'utils/StringUtil'
import ProgressBar from 'components/progress/ProgressBar'

const SimpleKeyFigurePanel = ({
    data,
    showAllValues,
    oneStatPerLine = false,
    loading,
}) => {
    const filterValue = useMemo(() => showAllValues ? data : filter(data, o => o.value && o.value !== '0'), [data, showAllValues])

    const getLabelDate = (d) => {
        if (d.typeValue) {
            if (d.typeValue === DATE) {
                return [getDate(d.value), getDate(d.value)]
            }
            return [getLongNumber(d.value), getNumberFormat(d.value)]
        }
        if (!isNaN(Number(d.value))) return [getLongNumber(d.value), getNumberFormat(d.value)]
        return [d.value, d.value]
    }

    return (
        <Card sx={{ backgroundColor: '#53a1ff' }}>
            <CardContent padding={6}>
                {loading ? <ProgressBar indeterminate withMessage sx={{ margin: '10px' }} /> : (
                    <Grid container size={12} columnSpacing={2.5} sx={{ color: 'white' }}>
                        {filterValue.map((d, idx) => {
                            const [value, tooltipValue] = getLabelDate(d)
                            const title = getI18nOrLabel(d.title)
                            const tooltip = !isUndefined(d.tooltip) ? getI18nOrLabel(d.tooltip) : ''
                            const tooltipContent = `${tooltip || title || ''} : ${tooltipValue}`
                            return (
                                <Grid
                                    key={idx}
                                    container
                                    size={ oneStatPerLine ? 12 :'auto'}
                                    direction='column'
                                    justifyContent='flex-start'
                                    alignItems={ oneStatPerLine ? 'flex-start' : 'flex-end'}
                                >
                                    <span style={{ fontSize: 15 }}>{title}</span>
                                    <Tooltip title={tooltipContent}>
                                        <span style={{ fontSize: 25 }}>{isNaN(Number(value)) ? value : formatMilliers(value)}</span>
                                    </Tooltip>
                                </Grid>
                            )
                        })}
                    </Grid>
                )}
            </CardContent>
        </Card>
    )
}
SimpleKeyFigurePanel.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        tooltip: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        typeValue: PropTypes.string,
    })),
    showAllValues: PropTypes.bool,
    oneStatPerLine: PropTypes.bool,
    loading: PropTypes.bool,
}

export default SimpleKeyFigurePanel
